import React from 'react';
import { motion } from 'framer-motion';
import HeroSection from '../components/HeroSection';
import SegmentationGate from '../components/SegmentationGate';
import ExplorerPath from '../components/ExplorerPath';
import StrategistPath from '../components/StrategistPath';
import MasterPath from '../components/MasterPath';
import CoreOfferingSection from '../components/CoreOfferingSection';
import CurriculumSection from '../components/CurriculumSection';
import InvestmentSection from '../components/InvestmentSection';
import FAQSection from '../components/FAQSection';
import FinalCTASection from '../components/FinalCTASection';
import Navigation from '../components/Navigation';

const LandingPage = () => {
  return (
    <motion.div 
      className="min-h-screen bg-gradient-to-br from-slate-900 via-indigo-900 to-slate-900"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <Navigation />
      <HeroSection />
      <SegmentationGate />
      <ExplorerPath />
      <StrategistPath />
      <MasterPath />
      <CoreOfferingSection />
      <CurriculumSection />
      <InvestmentSection />
      <FAQSection />
      <FinalCTASection />
    </motion.div>
  );
};

export default LandingPage;